import React from "react";

export interface FaqItem {
  question: string;
  answer: string;
}

interface FaqSectionProps {
  id?: string;
  eyebrow: React.ReactNode;
  heading: React.ReactNode;
  intro?: React.ReactNode;
  faqs: FaqItem[];
  footer?: React.ReactNode;
}

const FaqSection: React.FC<FaqSectionProps> = ({ id, eyebrow, heading, intro, faqs, footer }) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <section id={id} className="cs-section cs-faq">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <div className="cs-faq-inner">
        <div className="cs-faq-head">
          <div className="eyebrow">{eyebrow}</div>
          <h2>{heading}</h2>
          {intro && <p>{intro}</p>}
        </div>

        <div className="cs-faq-list">
          {faqs.map((faq) => (
            <details key={faq.question} className="cs-faq-item">
              <summary>
                <h3>{faq.question}</h3>
              </summary>
              <p>{faq.answer}</p>
            </details>
          ))}
        </div>

        {footer && <p className="cs-faq-footer">{footer}</p>}
      </div>
    </section>
  );
};

export default FaqSection;
